var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChevronIcon = function SvgChevronIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.193 3.96999C10.3338 3.82916 10.5248 3.75005 10.724 3.75005C10.9231 3.75005 11.1141 3.82916 11.255 3.96999C11.3958 4.11082 11.4749 4.30183 11.4749 4.50099C11.4749 4.70016 11.3958 4.89116 11.255 5.03199L6.52997 9.75599C6.38935 9.89644 6.19872 9.97533 5.99997 9.97533C5.80122 9.97533 5.6106 9.89644 5.46997 9.75599L0.744972 5.03199C0.604142 4.89116 0.525024 4.70016 0.525024 4.50099C0.525024 4.30183 0.604142 4.11082 0.744972 3.96999C0.885802 3.82916 1.07681 3.75005 1.27597 3.75005C1.47514 3.75005 1.66614 3.82916 1.80697 3.96999L5.99997 8.16299L10.193 3.96999V3.96999Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevronIcon.a331bd1e.svg";
export { ForwardRef as ReactComponent };